import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterUserManagement from 'views/userManagement/userManagement/filterUserManagement'; // Importing filter component for user management
import TableUserManagement from 'views/userManagement/userManagement/tableUserManagement'; // Importing table component for user management
import DetailsUserManagement from 'views/userManagement/userManagement/detailsUserManagement'; // Importing details component for user management
import RecordUserManagement from 'views/userManagement/userManagement/recordUserManagement'; // Importing record component for user management
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * UserManagementView class extending JetView
 */
export default class userManagementView extends JetView {
    /**
     * Configures the layout of the user management view
     * @returns {Object} Layout configuration
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Right side layout containing player view and user management components
        const right = {
            type: 'wide',
            rows: [PlayersView, DetailsUserManagement, RecordUserManagement],
        };

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };

        // Left side layout containing user management components
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Gestion de Usuario'), // Localized label for user management
                            width: 150,
                        },
                    ],
                },
                FilterUserManagement, // Filter component
                TableUserManagement, // Table component
                toolbar, // Pagination toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            cols: [left, right], // Combining left and right layouts
        };
    }
}

// FILE DOCUMENTED
